export default "__VITE_ASSET__BskEWFyu__"